<nb-card >

  <nb-card-body>
    <ngx-chartjs-multiple-xaxis [sensors] = "sensors" [interval]="interval"></ngx-chartjs-multiple-xaxis>
  </nb-card-body>
</nb-card>

